<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card
          elevation="0"
          outlined
          @drop.prevent="onDrop($event)"
          @dragover.prevent="dragover = true"
          @dragenter.prevent="dragover = true"
          @dragleave.prevent="dragover = false"
          :height="options ? options.height : 150"
        >
          <v-layout align-center justify-center fill-height>
            <v-card-text>
              <v-row
                v-if="!multiple && uploadedFiles.length ? false : true"
                class="d-flex flex-column"
                dense
                align="center"
                justify="center"
              >
                <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="40">
                  mdi-cloud-upload
                </v-icon>
                <p>
                  <a @click="$refs['file'].click()">{{
                    $t("Drop your file(s) here, or click to select them.")
                  }}</a>
                </p>
              </v-row>
              <v-row v-if="!multiple && uploadedFiles.length">
                <v-col cols="11">
                  <v-img
                    contain
                    max-height="350"
                    max-width="700"
                    :src="fileSrc"
                  ></v-img>
                </v-col>
                <v-col cols="1">
                  <v-btn depressed icon @click="deleteFile()">
                    <v-icon color="primaryred">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-virtual-scroll
                v-if="
                  uploadedFiles.length > 0 && multiple && showFilesInDropzone
                "
                :items="uploadedFiles"
                height="150"
                item-height="50"
              >
                <template v-slot:default="{ item }">
                  <v-list-item :key="item.name">
                    <v-list-item-content>
                      <v-list-item-title class="mr-4">
                        <v-row no-gutters>
                          <v-col>
                            <v-layout fill-height align-center>
                              {{ item.name }}
                            </v-layout>
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-layout>
                        <v-btn
                          depressed
                          :loading="loadingDelete"
                          @click.stop="removeFile(item)"
                          icon
                        >
                          <v-icon> mdi-close-circle </v-icon>
                        </v-btn>
                      </v-layout>
                    </v-list-item-action>
                  </v-list-item>

                  <v-divider></v-divider>
                </template>
              </v-virtual-scroll>
            </v-card-text>
          </v-layout>
        </v-card>

        <input
          ref="file"
          type="file"
          :multiple="multiple"
          style="display: none"
          label="upload file"
          :accept="accepts"
          @change="loadFiles($event)"
        />
      </v-col>
      <v-col cols="12" class="mt-4 text-right" v-if="needsUploadBtn">
        <v-btn
          depressed
          :disabled="uploadedFiles.length == 0"
          @click="uploadFile()"
        >
          {{ uploadBtnName }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>
  
  <script>
export default {
  props: {
    showFilesInDropzone: {
      typeof: Boolean,
      default: true,
    },
    usage: {},
    parentFiles: {},
    multiple: {
      typeof: Boolean,
    },
    uploadBtnName: {
      typeof: String,
    },
    uploadUrl: {
      typeof: String,
    },
    accepts: {
      typeof: Array,
    },
    needsUploadBtn: {
      typeof: Boolean,
    },
    autoUploadAfterSelect: {
      typeof: Boolean,
    },
    options: {
      typeof: Object,
    }
  },
  data() {
    return {
      dragover: null,
      uploadedFiles: [],
      fileNames: [],
      keyitem: null,
      loadingDelete: null,
      fileSrc: null,
      loadingItemInNewTab: null,
    };
  },
  watch: {
    parentFiles(newValue) {
      this.uploadedFiles = [];
      if (newValue) {
        if (newValue.length > 0) {
          for (let i = 0; i < newValue.length; i++) {
            this.uploadedFiles.push({ name: newValue[i] });
          }
        }
      }
    },
  },
  created() {
    if (this.parentFiles) {
      if (this.parentFiles.length > 0) {
        for (let i = 0; i < this.parentFiles.length; i++) {
          this.uploadedFiles.push({ name: this.parentFiles[i] });
        }
      }
    }
  },

  methods: {
    deleteFile() {
      this.fileSrc = null;
      this.uploadedFiles = [];
      this.fileNames = [];
    },
    uploadFile() {
      this.$emit("update:saving", true);
      let currentFiles = Array.prototype.slice.call(this.uploadedFiles);
      let formData = new FormData();
      
      if(this.multiple){
        for (var i = 0; i < currentFiles.length; i++) {
          formData.append("files", currentFiles[i]);
        }
      }else{
        formData.append("file", currentFiles[0]);
      }
      this.$request.post(this.uploadUrl, formData, (res) => {
        this.$emit("update:saving", false);

        if (res.success) {
          this.uploadedFiles = [];

          const toaster = {
            message: this.$t("File successfully uploaded"),
            timeout: false,
            type: "SUCCESS",
            toastClassName: ["toaster-color-success", "toaster-layout"],
            bodyClassName: ["toaster-text-layout"],
            icon: "mdi-check-circle",
          };
          this.$store.dispatch("setToaster", toaster);
          this.$emit("returnFilename", res.data);
        } else {
          this.snackbar = true;
          if (res.title) {
            const toaster = {
              message: res.title,
              timeout: false,
              type: "ERROR",
              toastClassName: ["toaster-color-error", "toaster-layout"],
              bodyClassName: ["toaster-text-layout"],
              icon: "mdi-alert-octagon",
            };
            this.$store.dispatch("setToaster", toaster);
          } else {
            const toaster = {
              message: this.$t(
                "Something went wrong while uploading, please try again."
              ),
              timeout: false,
              type: "ERROR",
              toastClassName: ["toaster-color-error", "toaster-layout"],
              bodyClassName: ["toaster-text-layout"],
              icon: "mdi-alert-octagon",
            };
            this.$store.dispatch("setToaster", toaster);
          }
        }
      });
    },
    removeFile(file) {
      this.loadingDelete = true;
      for (const key in this.uploadedFiles) {
        if (this.uploadedFiles[key].name == file.name) {
          this.$delete(this.uploadedFiles, key);
          this.loadingDelete = false;
        }
      }
    },
    removeFileOutOfArray(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex(
        (file) => file.name === fileName
      );
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
      //update parent component
      this.$emit("deleteItemOutOfFile", { use: this.usage, value: fileName });
      this.loadingDelete = false;
    },

    loadFiles(e) {
      let formData = new FormData();
      for (let i = 0; i < e.target.files.length; i++) {
        formData.append("files", e.target.files[i]);
        this.fileNames.push(e.target.files[i].name);
        this.uploadedFiles.push(e.target.files[i]);
        const file = e.target.files[i];
        // Ensure that you have a file before attempting to read it
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.fileSrc = e.target.result;
          };
          reader.readAsDataURL(file);
        }
      }
      if (this.autoUploadAfterSelect) {
        this.uploadFile();
      }
    },
    onDrop(e) {
      this.dragover = false;
      let formData = new FormData();
      for (var i = 0; i < e.dataTransfer.files.length; i++) {
        formData.append("files", e.dataTransfer.files[i]);
        this.fileNames.push(e.dataTransfer.files[i].name);
        this.uploadedFiles.push(e.dataTransfer.files[i]);
        const reader = new FileReader();
        reader.onload = (e) => {
          this.fileSrc = e.target.result;
        };
        reader.readAsDataURL(e.dataTransfer.files[i]);
      }
      if (this.autoUploadAfterSelect) {
        this.uploadFile();
      }
    },

    getUrlFromItem(item) {
      return URL.createObjectURL(item);
    },
  },
};
</script>
  
  <style >
</style>